import { observer } from 'mobx-react';
import React from 'react';
import { getQuestionComponentRegistryEntry } from '../component-registry';
import styles from './ResponseImage.m.sass';
export default observer(function (_ref) {
  var vm = _ref.vm;
  var entry = getQuestionComponentRegistryEntry(vm === null || vm === void 0 ? void 0 : vm.type);
  var image = entry ? entry.image : undefined;
  return image ? /*#__PURE__*/React.createElement("img", {
    className: styles.responseImage,
    src: image
  }) : null;
});
//# sourceMappingURL=index.js.map
